import React from 'react';

import Tooltip from '@mui/material/Tooltip'

import "./customtooltip.css"
export const CustomTooltip = ({title, children}) => {

  
  return (
    <div>
    <Tooltip title= {title}
       placement="bottom-start"
       enterDelay={700}
       componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "rgb(235, 233, 228)",
            color: "black",
            fontSize:'14px',
            fontWeight: '400',
          }
        }
      }}
       slotProps={{
            popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                   offset: [0,-8],
                },
              },
            ],
        },
    }}>
    
      {children}

    </Tooltip>
    </div>
  );

};

CustomTooltip.defaultProps = {
  disabled: false,

  rows: 4,
}
